import { render, staticRenderFns } from "./participantsTotals.vue?vue&type=template&id=6f5d0f0e&scoped=true&"
import script from "./participantsTotals.vue?vue&type=script&lang=js&"
export * from "./participantsTotals.vue?vue&type=script&lang=js&"
import style0 from "./participantsTotals.vue?vue&type=style&index=0&id=6f5d0f0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5d0f0e",
  null
  
)

export default component.exports